import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserContext } from 'contexts/UserContext';
import { LoadingPage } from 'v3/pages/LoadingPage';
import { UpdatePasswordPage } from 'v3/pages/UpdatePassword';
import { isAuthenticated } from '../../services/auth';
import RouteElement from '../../router/RouteElement';

const PrivateRoute = ({ title, component: Component, path }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    isUserActive,
    isLoading,
    shouldUserChangePassword,
    lastPasswordUpdate,
    isUserBlocked,
    isCooperMail } = useContext(UserContext);

  const authenticated = isAuthenticated();
  const currentDate = new Date();
  // Preserva o dia exato; se o mês de destino for mais curto (overflow do
  // Date nativo, ex.: 31/ago - 6 meses "vazaria" para março), faz clamp
  // para o último dia do mês de destino em vez de sempre usar o dia 1.
  const sixMonthsAgo = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 6,
    currentDate.getDate(),
  );
  if (sixMonthsAgo.getDate() !== currentDate.getDate()) {
    sixMonthsAgo.setDate(0);
  }
  const lastPasswordUpdateInDate = new Date(lastPasswordUpdate);
  const isLastUpdateLessThanSixMonths = lastPasswordUpdateInDate < sixMonthsAgo;
  const shouldRedirectToChangePasswordModal =
    !isCooperMail &&
    isUserActive &&
    authenticated &&
    !isUserBlocked &&
    (shouldUserChangePassword || isLastUpdateLessThanSixMonths);

  useEffect(() => {
    if (isUserActive && authenticated && !isUserBlocked) {
      dispatch({ type: 'CURRENT_PATH', path });
    }
  }, [dispatch, path, isUserActive, authenticated, isUserBlocked]);

  if (isLoading) {
    return <LoadingPage isLoading={isLoading} />;
  }

  if (shouldRedirectToChangePasswordModal) {
    return <UpdatePasswordPage />;
  }

  if (isUserActive && authenticated && !isUserBlocked) {
    return <RouteElement component={Component} path={path} />;
  }
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
  localStorage.removeItem('updatePushUserId');
  localStorage.removeItem('permissions');
  localStorage.removeItem('bot');
  localStorage.removeItem('issue_permission');

  return <Navigate to="/login" replace state={{ from: location.pathname }} />;
};

export default PrivateRoute;
